import actionTypes from './GISTTPTR01ActionType';

/**
 * 実習計画テンプレート登録
 */
const initialState = {
    isFetching: false,
    data: [],
    isError: false,
    err_type: "",
    err_detail: []
};

/**
 * 実習計画テンプレートを更新するReducer
 * @param {*} state
 * @param {*} action
 */
export const saveTrainingPlanTemplateInfo = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.SAVE_TRAINING_PLAN_TEMPLATE_REQUEST:
            return Object.assign({}, state, {
                isFetching: true,
                data: [],
                isError: false,
                err_type: "",
                err_detail: []
            });
        case actionTypes.SAVE_TRAINING_PLAN_TEMPLATE_SUCCESS:
            return Object.assign({}, state, {
                isFetching: false,
                data: action.data.data,
                isError: false,
                err_type: action.data.err_type,
                err_detail: action.data.err_detail
            });
        case actionTypes.SAVE_TRAINING_PLAN_TEMPLATE_FAILURE:
            return Object.assign({}, state, {
                isFetching: false,
                data: {},
                isError: true,
                err_type: action.err,
                err_detail: []
            });
        case actionTypes.SAVE_TRAINING_PLAN_TEMPLATE_RESET:
            return Object.assign({}, state, {
                isFetching: false,
                isError: false,
                data: {},
                err_type: "",
                err_detail: []
            });
        default:
            return state;
    }
};
